import React from "react";

import { ClickableComponent, IClickableComponentProps } from "@app/core/clickable";
import IconChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { MerchantCardWrapper } from "@app/modules/merchant-card-wrapper/merchant-card-wrapper";
import { IOutFeaturedMerchantDTO } from "@app/core/new-merchant-card/featured-merchants.interface";
import { formatMessage } from "@app/translations/intl";

import styles from "../search-results.module.scss";

interface IProps {
  headerText: string;
  button: IClickableComponentProps;
  merchants: IOutFeaturedMerchantDTO[];
  count?: number;
  closeSearch: () => void;
}

const component = ({ headerText, button, merchants, count, closeSearch }: IProps) => {
  return (
    <div className={styles.searchResultContainer}>
      <div className={styles.header}>
        {headerText} {(count || 0) > 0 ? `(${count})` : ""}
      </div>
      <div className={styles.body}>
        <div className={styles.cardGrid}>
          {merchants.map((merchant) => (
            <span key={merchant.id} role="button" onClick={closeSearch}>
              <MerchantCardWrapper merchant={merchant} variant="mobile-search" responsive />
            </span>
          ))}
        </div>

        <div onClick={closeSearch} className={styles.link}>
          <ClickableComponent
            {...button}
            iconStyle="filled"
            iconRight={IconChevronRight}
            iconFillColor="white"
            iconSize="14px"
            variant="primary-2025-brand"
            href={formatMessage({ id: "global.merchantOverviewLink" })}
          />
        </div>
      </div>
    </div>
  );
};

export const NavBarResultMerchants = component;
